import React from 'react';

const ProjectTwrsIndex = React.lazy(() => import("./index"))
const NewProjectTwrs = React.lazy(() => import("./new"))
const EditProjectTwrs = React.lazy(() => import("./edit"))

export default[
	{path:'/project/:project_id/twrs/:id/edit',component: EditProjectTwrs,name:'Edit ProjectTwr'},
	{path:'/project/:project_id/twrs/new',component: NewProjectTwrs,name:'New ProjectTwr'},  
	{path:'/project/:project_id/twrs',component: ProjectTwrsIndex,name:'ProjectTwrs'}, 
]

// import ProjectTwrsRoutes from "modules/project/twrs/web/routes"
// routes = _.concat(routes,ProjectTwrsRoutes)
